/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFBreachSourceItem } from './CRSFBreachSourceItem';
import {
    CRSFBreachSourceItemFromJSON,
    CRSFBreachSourceItemFromJSONTyped,
    CRSFBreachSourceItemToJSON,
} from './CRSFBreachSourceItem';

/**
 * 
 * @export
 * @interface CRSFEmailLeakAggregatedEvent
 */
export interface CRSFEmailLeakAggregatedEvent {
    /**
     * 
     * @type {string}
     * @memberof CRSFEmailLeakAggregatedEvent
     */
    email: string;
    /**
     * 
     * @type {CRSFBreachSourceItem}
     * @memberof CRSFEmailLeakAggregatedEvent
     */
    source: CRSFBreachSourceItem;
}

/**
 * Check if a given object implements the CRSFEmailLeakAggregatedEvent interface.
 */
export function instanceOfCRSFEmailLeakAggregatedEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function CRSFEmailLeakAggregatedEventFromJSON(json: any): CRSFEmailLeakAggregatedEvent {
    return CRSFEmailLeakAggregatedEventFromJSONTyped(json, false);
}

export function CRSFEmailLeakAggregatedEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFEmailLeakAggregatedEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'source': CRSFBreachSourceItemFromJSON(json['source']),
    };
}

export function CRSFEmailLeakAggregatedEventToJSON(value?: CRSFEmailLeakAggregatedEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'source': CRSFBreachSourceItemToJSON(value.source),
    };
}

